// Point d'accroche unique pour la journalisation des erreurs front (futur Sentry ou equivalent).

// Une erreur HTTP (axios) embarque la requête entière : son corps — un mot de
// passe à la connexion, un salaire ailleurs —, ses en-têtes et la réponse du
// serveur. Rien de cela ne doit atteindre un journal : on n'en garde que de
// quoi situer l'échec.
export function resumerErreur(erreur) {
    if (!erreur || typeof erreur !== 'object' || !(erreur.config || erreur.request || erreur.response)) {
        return erreur;
    }
    return {
        message: erreur.message,
        code: erreur.code,
        statut: erreur.response?.status,
        methode: erreur.config?.method,
        url: erreur.config?.url,
    };
}

export function signalerErreur(erreur, contexte) {
    console.error(`[${contexte}]`, resumerErreur(erreur));
}
